<template>
  <div class="aff-apply-page">
    <div class="aff-apply-card">
      <div class="aff-apply-logo">
        <img src="/logo.png" alt="JILI" class="aff-logo-img" @error="$event.target.style.display='none'" />
        <h1>JILI 合作夥伴申請</h1>
        <p class="aff-apply-sub">填寫以下資料，審核通過後將以 Email 通知您</p>
      </div>

      <form @submit.prevent="submit" class="aff-apply-form" autocomplete="off">
        <div class="aff-field">
          <label>姓名 *</label>
          <input v-model="form.name" type="text" placeholder="請輸入您的姓名" required />
        </div>
        <div class="aff-field">
          <label>登入帳號 *</label>
          <input v-model="form.username" type="text" placeholder="自訂登入帳號（英數字）" required autocomplete="off" />
        </div>
        <div class="aff-field">
          <label>Email *</label>
          <input v-model="form.email" type="email" placeholder="作為聯絡信箱使用" required autocomplete="off" />
        </div>
        <div class="aff-field">
          <label>密碼 *</label>
          <input v-model="form.password" type="password" placeholder="請設定您的登入密碼（至少 6 碼）" required minlength="6" autocomplete="new-password" />
        </div>
        <div class="aff-field">
          <label>確認密碼 *</label>
          <input v-model="form.confirmPassword" type="password" placeholder="請再次輸入密碼" required autocomplete="new-password" />
        </div>
        <div class="aff-field">
          <label>手機號碼 *</label>
          <input v-model="form.phone" type="tel" placeholder="請輸入手機號碼" required autocomplete="off" />
        </div>

        <div class="aff-divider">銀行帳戶（選填，審核通過後可至後台補填）</div>

        <div class="aff-field-row">
          <div class="aff-field">
            <label>銀行代碼</label>
            <input v-model="form.bank_code" type="text" placeholder="例：004" />
          </div>
          <div class="aff-field">
            <label>戶名</label>
            <input v-model="form.bank_holder" type="text" placeholder="帳戶持有人姓名" />
          </div>
        </div>
        <div class="aff-field">
          <label>銀行帳號</label>
          <input v-model="form.bank_account" type="text" placeholder="請輸入完整帳號" />
        </div>

        <!-- 合作夥伴條約 -->
        <div class="aff-terms-wrap">
          <div class="aff-terms-header" @click="termsOpen = !termsOpen">
            <span class="aff-terms-title">📋 合作夥伴條約</span>
            <span class="aff-terms-toggle">{{ termsOpen ? '▲ 收起' : '▼ 展開閱讀' }}</span>
          </div>
          <div v-show="termsOpen" class="aff-terms-body">
            <p class="aff-terms-section"><strong>一、遵守法規</strong><br>
            合作夥伴應遵守中華民國相關法令，包含但不限於消費者保護法、公平交易法、個人資料保護法及相關行業法規，不得從事任何違法或侵害他人權益之行為。</p>

            <p class="aff-terms-section"><strong>二、誠實宣傳，不誇大功效</strong><br>
            推廣服務或產品時，所有宣傳內容須符合實際情形，不得以誇大、不實或誤導性方式描述效果，不得使用「保證治療」、「百分之百有效」等不實字眼，避免消費者產生不合理期待。</p>

            <p class="aff-terms-section"><strong>三、專業服務態度</strong><br>
            應以誠懇、尊重的態度對待每一位客人，不得有言語不當、態度惡劣、歧視或任何損害客人體驗與權益之行為，客人有任何疑慮應耐心溝通說明。</p>

            <p class="aff-terms-section"><strong>四、個人資料保護</strong><br>
            妥善保管客人個人資料，不得未經授權外洩、轉售或挪作他用，應遵守個人資料保護法相關規定，違者依法處理。</p>

            <p class="aff-terms-section"><strong>五、禁止不正當行為</strong><br>
            禁止從事欺詐、偽造文件、惡意刷單、操控評價或任何損害 JILI 平台及消費者信任之行為，不得以任何方式規避平台規範。</p>

            <p class="aff-terms-section"><strong>六、違規處理與終止條款</strong><br>
            若合作夥伴有違反上述條款，或有損害 JILI 平台、客人或其他合作夥伴權益之行為，JILI 有權在不事先通知的情況下，立即暫停或永久終止合作契約，並保留追究相關民事或刑事責任之權利。</p>

            <p class="aff-terms-section"><strong>七、條款修訂</strong><br>
            JILI 保留隨時修改本條款之權利，修改後將於平台公告，合作夥伴繼續使用即視為同意修改後之內容。</p>
          </div>
          <label class="aff-terms-check">
            <input type="checkbox" v-model="agreedToTerms" />
            <span>我已閱讀並同意以上合作夥伴條約</span>
          </label>
        </div>

        <div v-if="error" class="aff-error">{{ error }}</div>
        <div v-if="success" class="aff-success">{{ success }}</div>

        <button type="submit" class="aff-btn-submit" :disabled="loading || !agreedToTerms">
          {{ loading ? '送出中...' : '送出申請' }}
        </button>

        <p class="aff-login-link">已有帳號？<a href="/affiliate/login">前往登入</a></p>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import axios from 'axios'

const form = reactive({
  name: '', username: '', email: '', password: '', confirmPassword: '', phone: '',
  bank_code: '', bank_account: '', bank_holder: ''
})
const loading      = ref(false)
const error        = ref('')
const success      = ref('')
const agreedToTerms = ref(false)
const termsOpen    = ref(false)

async function submit() {
  error.value = ''
  success.value = ''
  if (!agreedToTerms.value) {
    error.value = '請先閱讀並同意合作夥伴條約'
    return
  }
  if (form.password.length < 6) {
    error.value = '密碼至少需要 6 碼'
    return
  }
  if (form.password !== form.confirmPassword) {
    error.value = '兩次輸入的密碼不一致'
    return
  }
  loading.value = true
  try {
    const res = await axios.post('/api/affiliate/apply', form)
    if (res.data.success) {
      success.value = res.data.message
      Object.assign(form, { name:'', username:'', email:'', password:'', confirmPassword:'', phone:'', bank_code:'', bank_account:'', bank_holder:'' })
      agreedToTerms.value = false
      termsOpen.value = false
    } else {
      error.value = res.data.message || '申請失敗'
    }
  } catch (e) {
    error.value = e.response?.data?.message || '伺服器錯誤，請稍後再試'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.aff-apply-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f0eb 0%, #ede0d4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}
.aff-apply-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 480px;
}
.aff-apply-logo {
  text-align: center;
  margin-bottom: 1.5rem;
}
.aff-logo-img { height: 48px; margin-bottom: 0.5rem; }
.aff-apply-logo h1 { font-size: 1.4rem; color: #4a2c1a; margin: 0.3rem 0; }
.aff-apply-sub { color: #888; font-size: 0.88rem; margin: 0; }
.aff-apply-form { display: flex; flex-direction: column; gap: 1rem; }
.aff-field { display: flex; flex-direction: column; gap: 0.3rem; }
.aff-field label { font-size: 0.85rem; font-weight: 600; color: #555; }
.aff-field input {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0.6rem 0.9rem;
  font-size: 0.95rem;
  outline: none;
  transition: border-color 0.2s;
}
.aff-field input:focus { border-color: #8B4513; }
.aff-field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 0.8rem; }
.aff-divider {
  font-size: 0.8rem;
  font-weight: 600;
  color: #888;
  border-top: 1px solid #eee;
  padding-top: 0.8rem;
  margin-top: 0.2rem;
}

/* 條約區塊 */
.aff-terms-wrap {
  border: 1px solid #e0d4c8;
  border-radius: 10px;
  overflow: hidden;
  background: #fdf9f6;
}
.aff-terms-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  cursor: pointer;
  user-select: none;
  background: #f5ede4;
  transition: background 0.15s;
}
.aff-terms-header:hover { background: #ede0d4; }
.aff-terms-title { font-size: 0.9rem; font-weight: 700; color: #4a2c1a; }
.aff-terms-toggle { font-size: 0.78rem; color: #8B4513; font-weight: 600; white-space: nowrap; }
.aff-terms-body {
  padding: 1rem 1.1rem 0.5rem;
  max-height: 260px;
  overflow-y: auto;
  border-top: 1px solid #e0d4c8;
}
.aff-terms-section {
  font-size: 0.83rem;
  color: #444;
  line-height: 1.75;
  margin: 0 0 0.85rem;
}
.aff-terms-section strong { color: #4a2c1a; }
.aff-terms-check {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid #e0d4c8;
  cursor: pointer;
  font-size: 0.86rem;
  font-weight: 600;
  color: #4a2c1a;
}
.aff-terms-check input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #8B4513;
  cursor: pointer;
  flex-shrink: 0;
}

.aff-error { background: #fff0f0; color: #c0392b; padding: 0.7rem 1rem; border-radius: 8px; font-size: 0.9rem; }
.aff-success { background: #f0fff4; color: #27ae60; padding: 0.7rem 1rem; border-radius: 8px; font-size: 0.9rem; }
.aff-btn-submit {
  background: #8B4513;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.8rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.3rem;
}
.aff-btn-submit:hover:not(:disabled) { background: #6b3310; }
.aff-btn-submit:disabled { background: #ccc; cursor: not-allowed; }
.aff-login-link { text-align: center; font-size: 0.88rem; color: #666; margin-top: 0.3rem; }
.aff-login-link a { color: #8B4513; font-weight: 600; }
</style>
